export default function Pill({ label, color, bg }) {
  return (
    <span className="pill" style={{ background: bg || color + '22', color, border: `1px solid ${color}55` }}>
      {label}
    </span>
  );
}
